<template>
	<contentBox v-if="!loadError" v-bind:loading="!recLoaded">
		<contentTitle v-if="overlay" label="OVERLAY" close="home">
			<h2 class="text-white font-weight-light pb-2">{{overlay.name}}</h2>
		</contentTitle>
		<contentBody v-if="overlay" v-bind:locked="token === null">
			<contentActions v-if="overlay">
				<button class="btn btn-outline-light btn-sm" v-bind:class="{active:shareShown === true}" v-on:click="share">
					<i class="material-icons md-18" title="share overlay">share</i> 
					Share
				</button>
				<button class="btn btn-outline-light btn-sm" v-on:click="zoomTo">
					<i class="material-icons md-18" title="center map on overlay">place</i> 
					Center
				</button>
				<button v-if="isAdmin" class="btn btn-outline-light btn-sm" v-on:click="edit">
					<i class="material-icons md-18" title="edit overlay">edit</i> 
					Edit
				</button>
			</contentActions>
			<share v-if="shareShown" v-bind:link="location" @close="share"></share>
			<div v-else>
				<div class="p-3">
					<div class="lock-block" v-if="token === null">
						<div class="row mx-0 hover-dk" v-on:click="routeLogin">
							<div class="col-2 text-center my-auto">
								<i class="material-icons text-light mr-3 md-36">account_box</i>
							</div>
							<div class="py-3 col-10 pl-0 pr-3 py-3">
								<h5 class="mb-0 text-white">Sign in to view</h5>
								<h5 class="mb-0 font-weight-light text-light">Get details on overlay parcel restrictions</h5>
							</div>
						</div>
					</div>
					<div class="category-body">
						<div class="category">
							<div class="category-title">DESCRIPTION</div>
							<div class="property-row">
								<div class="text-break">
									{{overlay.description || 'No description available'}}
								</div>
							</div>
						</div>
						<div v-if="overlay.details" class="category">
							<div class="category-title">DETAILS</div>
							<div v-for="(detail, index) in overlay.details" class="property-row">
								<label>{{detail.name}}</label>
								<div class="property-value-right property-locked">
									{{detail.value || '-'}}
								</div>
							</div>
						</div>
						<div v-if="overlay.jurisdiction !== null && overlay.jurisdiction.name !== null" class="category">
							<div class="category-title">JURISDICTION</div>
							<div class="property-row">
								<div class="text-description property-locked">{{overlay.jurisdiction.name}}</div>
							</div>
						</div>
						<div v-if="isReference(overlay)" class="category">
							<div class="category-title">REFERENCES</div>
							<div v-for="(ref, idx) in overlay.references" class="property-row">
								<label>{{ref.description}}</label>
								<div class="property-value-right">
									<a :href="ref.url" target="_blank"><i class="material-icons md-12">open_in_new</i> Link</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import share from '../share/share';

export default {
	name: 'overlay-full',
	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		share
	},
	computed: {
		isAdmin: function(){
			return this.$store.state.agent.rec && this.$store.state.agent.rec.role.name && this.$store.state.agent.rec.role.name === 'admin';
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		overlay: function() {
			return this.$store.state.overlay.rec;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		mapCenter: function(){
			return {lat:this.$store.state.map.params.lat,lng:this.$store.state.map.params.lng};
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		location:function(){
			return window.location.href;
		},
		mapMoveDone:function(){
			return this.$store.state.map.fitBoundsDone;
		},
		flyToDone:function(){
			return this.$store.state.map.flyToDone;
		},
		mapFeatureQueryFound:function(){
			return this.$store.state.map.featureQueryFound;
		}
	},
	created: function(){
		this.recLoaded = false;
		this.getRec();
	},
	data: function(){
		return {
			recLoaded:false,
			shareShown:false,
			loadError:null
		}
	},
	beforeDestroy: function(){
		this.$store.dispatch('OVERLAY_HIGHLIGHT_CLEAR',{});
		this.$store.dispatch('OVERLAY_VISIBLE_CLEAR',{});
		this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_ON','zoning');
	},
	methods: {
		checkInside:function(){
			const bbox = this.overlay.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom >= 17 || this.mapZoom <= 12) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.overlay || !this.mapLoaded) return;
			this.ready();
		},
		checkZoom:function(){
			if (this.mapZoom >= 15 || this.mapZoom <= 12) return false;
			return true;
		},
		edit:function(){
			this.$router.push({
				name: 'overlay-edit',
				params:{
					id: this.$route.params.id
				}
			});
		},
		getRec: function(){
			this.loadError = null;
			this.recLoaded = false;
			this.$store.dispatch('OVERLAY_GET', {
				id: this.$route.params.id
			}).catch((error)=>{
				this.loadError = error;
			});
		},
		highlight:function(){
			this.$store.dispatch('OVERLAY_VISIBLE');
			this.$store.dispatch('OVERLAY_HIGHLIGHT',{});
		},
		isReference:function(overlay){ // check if overlay has references
			if (!overlay.references || overlay.references.length < 1) return false
			for (let i=0,len=overlay.references.length;i<len;i++){
				if (overlay.references[i].description) return true
			}
			return false
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else if (!this.checkZoom()){
				this.$store.dispatch('MAP_FLY_TO',{
					zoom:15
				});
			}
			else this.highlight();
			this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_OFF','zoning');
			this.updateTitleTag();
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeLogin:function(){
			this.$router.push({
				name: 'auth', 
				params:{}
			});
		},
		share:function(){
			if (this.shareShown){
				this.shareShown = false;
				return;
			}
			if (navigator.share){
				navigator.share({
				  title: document.title,
				  text: 'Overlay data for '+this.overlay.name,
				  url: window.location.href,
				});
				return;
			}

			this.shareShown = true;
		},
		updateTitleTag:function(){
			document.title = this.overlay.name+' - Scoutred Maps';
		},
		zoomTo:function(){
			this.$store.dispatch('OVERLAY_ZOOM_TO',{coords:this.mapCenter});
		},
	},
	watch: {
		$route:function(toRoute, fromRoute){
			if (fromRoute && toRoute.params.id !== fromRoute.params.id){ // route resource has changed
				this.getRec();
			}
		},
		mapLoaded:function(){
			this.checkReady();
		},
		overlay:function(toRec, fromRec){
			this.checkReady();
			if (this.overlay){
				this.recLoaded = true;
			}
		},
		mapMoveDone:function(){
			this.highlight();
		},
		flyToDone:function(){
			this.highlight();
		}
	}
}
</script>
<style>
.other-features{
	margin:1rem -1rem -1rem -1rem;
		background-color:#f8f9fa;
		padding:1rem;
}
.other-features-head{
	color: #8FA3AE;
	font-weight: 700;
	font-size:0.8rem;
}
.other-features-category{
		border-bottom:1px solid #E0E0E0;
		margin-bottom:1rem;
	}

</style>


// WEBPACK FOOTER //
// src/components/overlay/overlay-full.vue